import { validateZenodoFile } from "./utilities/schemaValidation.js";
export class ZenodoFile {
    zenodo;
    value;
    constructor(zenodo, file) {
        this.value = validateZenodoFile(file);
        this.zenodo = zenodo;
    }
    async getContentResponse() {
        const link = this.value.links.download;
        const response = await fetch(link, {
            headers: {
                Authorization: `Bearer ${this.zenodo.accessToken}`,
            },
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch ${link}`);
        }
        return response;
    }
}
//# sourceMappingURL=ZenodoFile.js.map